<template>
	<div>
		<div id="wHeader">
			<div id="H_left"></div>
			<div id="wNav">
				<div id="VR" style="clear: both;">
					<div style="float: right;margin-top: 15px;line-height: 50px;" id="jsdt">
					</div>
				</div>
				<div id="nav">
					<router-link id="nav_1" tag="div" :to="{path:'/Homepage'}"><div>首页</div></router-link>
					<router-link id="nav_2" tag="div" :to="{path:'/Exhibitioninfo'}"><div>展览</div></router-link>
					<router-link id="nav_3" tag="div" :to="{path:'/Social'}"><div>社教</div></router-link>
					<router-link id="nav_4" tag="div" :to="{path:'/Wenchuang'}"><div>文创</div></router-link>
					<router-link id="nav_5" tag="div" :to="{path:'/Collection'}"><div>馆藏</div></router-link>
					<router-link id="nav_6" tag="div" :to="{path:'/Informations'}"><div>资讯</div></router-link>
					<router-link id="nav_7" tag="div" :to="{path:'/Aboutqb'}"><div>关于</div></router-link>
				</div>
			</div>
		</div>
		<div id="mobile">
			<div id="btn" @click="showCont" style="width: 60px;height: 60px;position: absolute;right: 3%;top: 10px;"><img style="width: 100%;height: 100%;" src="../assets/img/Btn.png"></div>
			<div id="mwNav" v-if="show">
				<div id="mnav">
					<router-link id="mnav_1" tag="div" :to="{path:'/Homepage'}"><span>首页</span></router-link>
					<router-link id="mnav_2" tag="div" :to="{path:'/Exhibitioninfo'}"><span>展览</span></router-link>
					<router-link id="mnav_3" tag="div" :to="{path:'/Social'}"><span>社教</span></router-link>
					<router-link id="mnav_4" tag="div" :to="{path:'/Wenchuang'}"><span>文创</span></router-link>
					<router-link id="mnav_5" tag="div" :to="{path:'/Collection'}"><span>馆藏</span></router-link>
					<router-link id="mnav_6" tag="div" :to="{path:'/Informations'}"><span>资讯</span></router-link>
					<router-link id="mnav_7" tag="div" :to="{path:'/Aboutqb'}"><span>关于</span></router-link>
					<div @click="JupUrlVRTB" style="display: none;">唐蕃古道-VR</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default{
		name: 'Home',
		data(){
			return{
				seen:true,
				current:0,
				show:false
			}
		},
		methods:{
	    	showCont:function(){
				this.show = !this.show;
			},
			JupUrlVRTB:function(){
				window.open("http://huitailang.mzgtuan.com/project/26/")
		    },
		    isMobile() {
		        let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
		        return flag;
		    },
		    zhis:function(){
				window.open("http://bwg.cnki.net/index_qinghai.html")
		    }
	    },
		mounted(){
			if(this.isMobile()){
				$("#mobile").css("display","block");
				let SecondWidth = document.body.clientWidth;
				let wHeight = SecondWidth/(980/180) + 'px';
				$('#mobile').css('height',wHeight);
				$('#btn').css('line-height',wHeight);
			}else{
				$("#wHeader").css("display","block");
				let SecondWidth = document.body.clientWidth;
				let wHeight = SecondWidth/(1980/230) + 'px';
				$('#wHeader').css('height',wHeight);
				$('#VR').css('height',(SecondWidth/(1980/230))/2 + 'px');
//				$('#VR').css('line-height',(SecondWidth/(1980/230))/2-20 + 'px');
				$('#nav').css('height',(SecondWidth/(1980/230))/2 + 'px')
				for(let i=1;i<8;i++){
					$('#nav_'+i+'').css('width',(SecondWidth*0.4)/7 + "px");
					$('#nav_'+i+'>div').css('margin-left',((SecondWidth*0.4)/7-40)/2 + "px");
				};
			}
		}
	}
</script>

<style>
    #wHeader{
		width: 100%;
		background-image: url(../assets/img/header/header.jpg);
		background-size: 100% 100%;
		position: relative;
		background-repeat:no-repeat;
		overflow: hidden;
		display: none;
	}
	#H_left{
		width: 50%;
	}
	#VR{
		text-align:right;
		margin-right: 65px;
	}
	#VR>span{
		cursor: pointer;
		color: rgb(149,111,23);
		font-size: 1.2em;
	}
	#VR>span:hover{
		color: #ffffff
	}
	#wNav>#nav{
		/*writing-mode: vertical-lr;
		-webkit-writing-mode: vertical-lr;
		writing-mode: tb-lr;
		letter-spacing: 8px;*/
		float: right;
		/*width: 45%;*/
		height: 50%;
		margin-right: 65px;
	}
	#wNav>#nav>div{
	    float: left;
	}
	#wNav>#nav>div>div{
		cursor: pointer;
		width: 1.56em;
		font-size: 1.56em;
	    color: rgb(149,111,23);
	    /*margin-left: 19px;*/
	}
	#wNav>#nav>div>div:hover{
		color: #ffffff;
	}
	#wHeader>#wNav>#nav>div:nth-child(1):hover{
	    color: #ffffff;
	}
	#wNav>#nav>div:nth-child(7){
		border-left: 4px solid rgb(149,111,23);
		border-right: 4px solid rgb(149,111,23);
	}
	#wNav>#nav>div:nth-child(2),
	#wNav>#nav>div:nth-child(3),
	#wNav>#nav>div:nth-child(4),
	#wNav>#nav>div:nth-child(5),
	#wNav>#nav>div:nth-child(6),
	#wNav>#nav>div:nth-child(1){
		border-left: 4px solid rgb(149,111,23);
	}
	#jsdt{
	    width: 250px;
	    font-size: 15px;
	    float: right;
	    text-align: center;
	    color: rgb(149,111,23);
	    cursor: pointer;
	    height: 50px;
	    margin-top: 15px;
	}
	#jsdt>div:nth-child(1){
		float: left;
		width: 200px;
		background: #dfd1bd;
		border: 1px solid #dfd1bd;
		border-radius: 5px;
	}
	#jsdt>div:nth-child(2){
		float: right;
		line-height: 20px;
		border:1px solid #FF763B;
		height: 20px;
		margin-top: 12px;
		color: #FFFFFF;
		border-radius: 5px;
		padding: 2px 5px;
	}
	#jsdt>div:nth-child(1)>span:nth-child(1){
		line-height: 25px;
	}
	#jsdt:hover{
		color: rgba(149,111,23,0.6);
	}
	@-webkit-keyframes masked-animation {
        0% {
            background-position: 0 0
        }
        to {
            background-position: -100% 0
        }
    }
    #jsdt>div:nth-child(2){
        color: hsla(0, 0%, 100%, .65);
        background-image: -webkit-linear-gradient(left, #FF9900, #FF2222 25%, #cddc39 50%, #FF2222 75%, #FF9900);
        -webkit-text-fill-color: transparent;
        -webkit-background-clip: text;
        -webkit-background-size: 200% 100%;
        -webkit-animation: masked-animation 2s infinite linear;
    }
    #jsdt>div:nth-child(2){
        -webkit-animation: masked-animation 0.5s infinite linear;
    }
/*mobile*/
#mobile{
	width: 100%;
	display: none;
	background-image: url(../assets/img/header/header.jpg);
	background-size: 100% 100%;
	position: relative;
	background-repeat:no-repeat;
}
#mwNav{
	width: 30%;
	background: #956f17;
	position: absolute;
	right: 2%;
	z-index: 9999;
	top: 80px;

}
#mnav>div:nth-child(1),
#mnav>div:nth-child(2),
#mnav>div:nth-child(3),
#mnav>div:nth-child(4),
#mnav>div:nth-child(5),
#mnav>div:nth-child(6),
#mnav>div:nth-child(7){
	line-height: 30px;
	border-bottom: 1px solid #ffffff;
	color: #ffffff;
}
#mnav>div:nth-child(8){
	line-height: 30px;
	color: #ffffff;
}
</style>



// WEBPACK FOOTER //
// src/components/Header.vue